import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import { css } from "styled-components"
import Block from "../../design-system/atoms/layout-primitives/block"
import Grid from "../shared/grid"
import TitleDivider from "../shared/title-divider"
import { T } from "../shared/typography.styles"
import {
  EmailLink,
  JobIcon,
  LowerText,
  LowerTitle,
  PositionCardContainer,
  PositionCardRequirements,
  PositionCardTitle,
  PositionCardWrapper,
  SectionContainer,
} from "./open-positions.style"

const PositionCard = ({ job }) => {
  const query = useStaticQuery(graphql`
    query {
      locationIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Job Posting Icons/location.svg"
        }
      ) {
        publicURL
      }
      timeIcon: file(
        relativePath: {
          eq: "4_COMPANY/Careers/Desktop/Job Posting Icons/time.svg"
        }
      ) {
        publicURL
      }
    }
  `)

  //use the two most specific location values
  const jobLocation = [job.city, job.state, job.country_id]
    .filter((x) => !!x)
    .slice(0, 2)
    .join(", ")

  return (
    <PositionCardWrapper
      href={`https://mappedin.applytojob.com/apply/${job.board_code}`}
      target="_blank"
      rel="noreferrer"
    >
      <PositionCardTitle>{job.title}</PositionCardTitle>
      <PositionCardRequirements>
        {jobLocation && (
          <li>
            <JobIcon src={query.locationIcon.publicURL} />
            {jobLocation}
          </li>
        )}
        {job.type && (
          <li>
            <JobIcon src={query.timeIcon.publicURL} />
            {job.type}
          </li>
        )}
      </PositionCardRequirements>
    </PositionCardWrapper>
  )
}

export default function OpenPositions({ jobs }) {
  return (
    Array.from(jobs).length > 0 && (
      <div id="open-positions">
        <TitleDivider text="Open Positions" />
        <SectionContainer>
          <Grid>
            <PositionCardContainer>
              {Array.from(jobs).map((job) => (
                <PositionCard key={job.id} job={job} />
              ))}
            </PositionCardContainer>

            <LowerTitle>Join our team today!</LowerTitle>
            <LowerText>
              Don't see a role that's right for you? <br />
              Send a message to{" "}
              <EmailLink href="mailto:careers@mappedin.ca">
                careers@mappedin.ca
              </EmailLink>{" "}
              and tell us your story.
            </LowerText>

            <Block
              col={{ sm: "1/-1", lg: "3/-3" }}
              variants={[
                css`
                  text-align: center;
                  ${T.sm.body.regular}
                  grid-column: 1 / -1;
                  margin-top: 16px;

                  & > br {
                    display: none;
                  }
                `,
                css`
                  ${T.md.body.regular}
                  margin-top: 24px;
                  & > br {
                    display: initial;
                  }
                `,
                css`
                  ${T.lg.body.regular}
                `,
              ]}
              as="p"
            >
              Mappedin welcomes applications from people with disabilities. We
              provide reasonable accommodations for candidates upon request
              through the recruitment process. For additional information,
              please email us at{" "}
              <EmailLink href="mailto:accessibility@mappedin.com">
                accessibility@mappedin.com
              </EmailLink>{" "}
              or call us at (519) 594-0102 and ask to speak to a member of the
              Human Resources team.
            </Block>
          </Grid>
        </SectionContainer>
      </div>
    )
  )
}
